import { EditSignIn } from './EditSignIn/EditSignIn';

export const EditSignInPage = () => {
  return <EditSignIn />;
};
